[
  {
    "code": "CG-11",
    "name": "Bouenza"
  },
  {
    "code": "CG-BZV",
    "name": "Brazzaville"
  },
  {
    "code": "CG-8",
    "name": "Cuvette"
  },
  {
    "code": "CG-15",
    "name": "Cuvette-Ouest"
  },
  {
    "code": "CG-5",
    "name": "Kouilou"
  },
  {
    "code": "CG-7",
    "name": "Likouala"
  },
  {
    "code": "CG-2",
    "name": "Lékoumou"
  },
  {
    "code": "CG-9",
    "name": "Niari"
  },
  {
    "code": "CG-14",
    "name": "Plateaux"
  },
  {
    "code": "CG-12",
    "name": "Pool"
  },
  {
    "code": "CG-13",
    "name": "Sangha"
  }
]